<template>
  <div class="card" @click="goToDetail(infoData)">
    <div class="card-header">
      <span :style="{position:'relative'}">
        <span>{{infoData.reason}}</span>
        <z-info :info="info" type="text" />
      </span>
      <span :style="{color:infoData.status == '2' ? '#FF483C' : '#999999'}">{{resultObj[infoData.status]}}</span>
    </div>
    <div class="card-body">
      <div class="card-body-left">
        <z-row>
        <z-col span="6">违规凭证:</z-col>
        <z-col span="17">{{type[infoData.reportType]}} <span v-show="['1','3'].includes(infoData.reportType)">(共{{infoData.evidenceCount}}条)</span></z-col>
      </z-row>
      <z-row>
        <z-col span="6">举报时间:</z-col>
        <z-col span="17">{{infoData.time}}</z-col>
      </z-row>
      <z-row>
        <!-- 名称加头像 -->
        <z-col span="6">对方昵称:</z-col>
        <z-col span="17">
            <z-image
            width="15"
            height="15"
            round
            :src="infoData.portrait"
            ></z-image>
            {{infoData.nickname}}
          </z-col>
      </z-row>
      </div>
      <div class="card-body-right">
        <!-- 首图 -->
        <z-image
        v-if="['1','3'].includes(infoData.reportType)"
        :src="infoData.firstPic"
        fit="fill"
        ></z-image>
      </div>
    </div>
    <div class="card-supply" v-show="infoData.status == '2'">
      <span></span>
      <z-button size="small" @click.stop="goToSupply(infoData)">补充凭证</z-button>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Row, Col, Image, Button, Info } from '@zz-common/zz-ui';
import { sethasread } from '@api/resourceApi'

export default {
  name: 'InfoCard',
  props: ['infoData'],
  data() {
    return {
      resultObj: {
        0: '处理中',
        1: '已完成',
        2: '等待补充证据'
      },
      type: {
        1: '商品',
        2: '私信',
        3: '订单',
        4: '其他',
        5: '视频',
        6: '图片',
        7: '短视频',
        8: 'url',
        9: '帖子',
        11: '直播'
      },
      info: this.infoData.iread == '1'
    }
  },
  components: {
    'z-row': Row,
    'z-col': Col,
    'z-image': Image,
    'z-button': Button,
    'z-info': Info
  },
  methods: {
    //点击进入详情
    goToDetail({ id = '', toUid = '', iread = '' }) {
      this.info = false
      if (iread == '1') {
        sethasread({ reportId: id })
      }
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/ReportDetial?id=${id}&toUid=${toUid}`,
        needClose: '0'
      })
    },
    //点击补充凭证
    goToSupply({ id = '', toUid = '', iread = '' }) {
      this.info = false
      if (iread == '1') {
        sethasread({ reportId: id })
      }
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/ReportSupplementDetial?reportId=${id}&beReportedUid=${toUid}&from=10`,
        needClose: '0'
      })
    }
  }

}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>